'use strict'

let self

export default self = {
  container : document.querySelector(".vertical-gallery"),
  selectedImage : null,
  nav : null,
  navItems : null,

  init : () => {
    self.selectedImage = self.container.querySelector(".selected-image")
    self.nav = self.container.querySelector("nav")
    self.navItems = self.container.querySelectorAll("nav button")
    Array.from(self.navItems).forEach( button => button.addEventListener("click", self.change) )
    self.navItems[0].click()
  },

  change : e => {
    let el = e.currentTarget
    let img = el.querySelector(".bg-image").style.backgroundImage
    let imgURL = img.match(/\((.*?)\)/)[1].replace(/('|")/g,'')

    if (self.nav.querySelector("button.active")) {
      self.nav.querySelector("button.active").classList.remove("active")
    }
    el.classList.add("active")

    self.selectedImage.style.backgroundImage = `url("${imgURL}")`
  }
}
